var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.98 2.103 12.424.03h-.333L6.045 2.05.654.029A.49.49 0 0 0 0 .48v13.97c0 .202.134.381.327.449l5.558 2.074a.48.48 0 0 0 .327 0l6.044-2.02 5.398 2.023a.49.49 0 0 0 .654-.449V2.552a.48.48 0 0 0-.327-.449m-17-.93 4.578 1.71v12.944L.98 14.118zm5.558 1.722 5.231-1.747v12.958l-5.23 1.747zm10.789 12.932-4.577-1.709V1.177l4.577 1.709z"
  })));
};
export default SvgMap;